<template>
    <div class="content">
        <header-bar />
        <div class="main-container">
            <referral-info-box class="info-box" />
            <referral-form />
        </div>
        <small class="disclaimer">
            {{ $t('disclaimer') }}
        </small>
    </div>
</template>

<script>
    import ReferralInfoBox from '@/components/ReferralInfoBox'
    import ReferralForm from '@/components/ReferralForm'
    import HeaderBar from '@/components/HeaderBar'

    export default {
        name: 'ReferralRoute',
        components: {
            ReferralInfoBox,
            HeaderBar,
            ReferralForm
        }
    }
</script>

<style scoped>
.content {
    width: 92%;
    margin: auto;
    height: 100vh;
}
.main-container {
    display: flex;
}
.info-box {
    width: 56%;
    flex-shrink: 0;
    margin-right: 80px;
}
.disclaimer {
    text-shadow: 0 0 5px rgb(0 0 0);
    font-size: 1rem;
    font-weight: 500;
    margin-left: 1rem;
    margin-top: .5rem;
    display: inline-block;
    color: #fff;
}
@media screen and (max-width: 1400px) {
        .info-box {
            margin-right: 30px;
        }
}
@media screen and (max-width: 970px) {
        .info-box {
            margin-right: 30px;
        }
}

@media screen and (max-width: 1200px) {
    .info-box {
        width: 100%;
    }
    .main-container  {
        flex-direction: column;
    }
    .info-box {
        margin-bottom: 60px;
    }
}
@media screen and (max-width: 800px) {
    .info-box {
        width: 100%;
    }
    .main-container  {
        flex-direction: column;
    }
    .info-box {
        margin-bottom: 20px;
    }
}

</style>
